import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/section-2-frame.png'
import _imports_1 from './images/animal.png'
import _imports_2 from './images/section-2-img.jpg'
import _imports_3 from '../../images/search.png'


const _withScopeId = n => (_pushScopeId("data-v-2a0b66f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "frame",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-title" }, " 재활용 프로그램 참여하기 ", -1))
const _hoisted_5 = { class: "paper" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<img class=\"img-animal\" src=\"" + _imports_1 + "\" data-v-2a0b66f8><h5 class=\"paper-title\" data-v-2a0b66f8> 온라인 </h5><h6 class=\"paper-subtitle\" data-v-2a0b66f8> 우리 집에서도 쉽게 참여해요! </h6><div class=\"page-desc\" data-v-2a0b66f8><div class=\"desc-title\" data-v-2a0b66f8> 수거 신청 전 꼭 읽어주세요. </div><div data-v-2a0b66f8> 1. 가플지우 캠페인에서는 더욱 올바른 재활용을 위해 <br data-v-2a0b66f8> 각각의 <strong data-v-2a0b66f8>수거 품목별로 별도</strong>로 구분하여 온라인 수거 신청을 <br class=\"d-block d-md-none\" data-v-2a0b66f8> 진행하고 있습니다. </div><br class=\"d-block d-md-none\" data-v-2a0b66f8><div data-v-2a0b66f8> 2. 아래 4가지 품목 중 수거 신청을 원하는 품목의<br class=\"d-block d-md-none\" data-v-2a0b66f8><strong data-v-2a0b66f8>그림을 클릭 후</strong><strong data-v-2a0b66f8> ‘수거 신청하기’ 버튼</strong>을 클릭해주세요. </div><br class=\"d-block d-md-none\" data-v-2a0b66f8><div data-v-2a0b66f8> 3. <strong data-v-2a0b66f8>연결된 페이지에서 ‘수거 신청하기’ 버튼</strong>을 클릭해주시면 <br class=\"d-block d-md-none\" data-v-2a0b66f8> 최종적으로 수거 신청이 완료됩니다. </div><p class=\"tip strong\" data-v-2a0b66f8> * 환경을 위해 한 번의 신청 시 최대한 많은 양의 플라스틱을 <br class=\"d-block d-md-none\" data-v-2a0b66f8> 담아 보내주시면 더욱 좋습니다. </p></div>", 4)
const _hoisted_10 = { class: "paper-bottom" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "paper-title" }, " 오프라인 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "paper-subtitle" }, " 가까운 이마트에서도 참여해요! ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_2
}, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 가까운 이마트로 가볼까요? ")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, [
  /*#__PURE__*/_createTextVNode(" 보다 많은 매장에서 만날 수 있도록"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 가플지우 캠페인을 응원해주세요! ")
], -1))

import Swiper from './section-swiper.vue';
  import { ref, watchEffect, computed } from 'vue';
  import { request, getProgramLink } from '@/utils';
  import _ from 'lodash';
  import { IEmartProgram } from '../../type';
  import waitDialogVue from '../wait-dialog.vue';

  export interface IProps {
    program: IEmartProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IEmartProgram
  }

  ;

  
  const programs = ref<IEmartProgram[]>([]);
  const showWaitDialog = ref(false);

  const fetchRelativePrograms = async (parentId: number | string) => {
    const { data } = await request.get('/programs', { params: { parent_id_eq: parentId, page: 0 } });
    programs.value = data as IEmartProgram[];
  };

  watchEffect(() => {
    const id = _.get(props.program, 'id');
    if (id) {
      fetchRelativePrograms(id);
    }
  });

  const slides = computed(() => {
    return [
      {
        image: require('./images/swiper-1.png'),
        imageMobile: require('./images/swiper-1-mobile.png'),
        indicator: require('./images/indicator-1.png'),
        indicatorActive: require('./images/indicator-active-1.png'),
        link: '',
      },
      {
        image: require('./images/swiper-2.png'),
        imageMobile: require('./images/swiper-2-mobile.png'),
        indicator: require('./images/indicator-2.png'),
        indicatorActive: require('./images/indicator-active-2.png'),
        link: '',
      },
      {
        image: require('./images/swiper-3.png'),
        imageMobile: require('./images/swiper-3-mobile.png'),
        indicator: require('./images/indicator-3.png'),
        indicatorActive: require('./images/indicator-active-3.png'),
        link: '',
      },
      {
        image: require('./images/swiper-4.png'),
        imageMobile: require('./images/swiper-4-mobile.png'),
        indicator: require('./images/indicator-4.png'),
        indicatorActive: require('./images/indicator-active-4.png'),
        link: '',
      }
    ].map((item, index) => {
      const program = programs.value[index];
      return {
        ...item,
        link: program ? getProgramLink(programs.value[index]) : ''
      };
    });
  });


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(Swiper, { slides: _unref(slides) }, null, 8, ["slides"]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _createVNode(_component_router_link, {
              to: { name: 'emart.shops' },
              target: "_blank",
              class: "link-button"
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _createVNode(waitDialogVue, {
      modelValue: showWaitDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showWaitDialog).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})